import type { GetStaticPaths, NextPage } from "next";

import { usePageview } from "../../hooks/use-pageview";
import type { LookbookProps } from "../../lookbook";
import { getLookbookProps } from "../../lookbook";
import { PreviewMode } from "../../providers/PreviewMode";
import { handleStaticProps } from "../../request_handler";
import { LookbookView } from "../../views/LookbookView";

export type PageProps = LookbookProps & {
  isPreviewMode: boolean;
};

const Page: NextPage<PageProps> = (props) => {
  const { lookbook, isPreviewMode } = props;

  usePageview({ lookbookId: lookbook.id, isPreviewMode });

  return (
    <PreviewMode isPreviewMode={isPreviewMode}>
      <LookbookView {...props} />
    </PreviewMode>
  );
};

export default Page;

export const getStaticProps = handleStaticProps<PageProps, { slug: string[] }>(
  async (ctx) => {
    const { params, preview } = ctx;

    const props = await getLookbookProps(params?.slug, "/lookbooks");

    if (!props) {
      return { notFound: true };
    }

    return {
      revalidate: 10,
      props: { ...props, isPreviewMode: preview ?? false },
    };
  },
);

export const getStaticPaths: GetStaticPaths<{
  slug: string[];
}> = async () => {
  return { paths: [], fallback: "blocking" };
};
